import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'hidden'];

  static values = { defaultCountry: String };

  connect() {
    // Turbo caches the page as-is; destroy() unwraps the input so the cached
    // copy re-enhances cleanly on restore.
    this.handleBeforeCache = () => this.teardown();
    document.addEventListener('turbo:before-cache', this.handleBeforeCache);

    // The widget and its stylesheet outweigh the rest of the kit's controllers
    // together and few pages carry a phone field, so both arrive on demand.
    Promise.all([import('intl-tel-input'), import('intl-tel-input/styles')]).then(
      ([{ default: intlTelInput }]) => {
        if (!this.element.isConnected) return;

        this.iti = intlTelInput(this.inputTarget, {
          initialCountry: this.defaultCountryValue,
          countrySelectorMode: 'DROPDOWN',
          countrySearch: true,
          separateDialCode: false,
          matchDropdownWidth: false,
          placeholderNumberPolicy: 'OFF',
          uiTranslations: {
            searchPlaceholder: 'Search country',
            searchEmptyState: 'No country found',
          },
          loadUtils: () => import('intl-tel-input/utils'),
        });
      }
    );
  }

  disconnect() {
    document.removeEventListener('turbo:before-cache', this.handleBeforeCache);
    this.teardown();
  }

  // Bound from the template on `input` and `countrychange`, both of which can
  // change the dial code the field resolves to.
  sync() {
    const digits = this.inputTarget.value.replace(/\D/g, '');
    const value = digits ? `+${digits}` : '';

    if (this.hasHiddenTarget) this.hiddenTarget.value = value;
    this.dispatch('change', { detail: { value } });
  }

  teardown() {
    if (!this.iti) return;

    this.iti.destroy();
    this.iti = null;
  }
}
